import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from '../sensors.module.scss';
import { ReactComponent as DeleteIcon } from '@assets/images/Fireboard/DeleteIcon.svg';
import { ReactComponent as EditPencil } from '@assets/images/Fireboard/editPencil.svg';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const NamedSensors = props => {
  const { namedSensors, onClickDeleteSensor, fieldValue, onClickEdit } = props;

  const filteredSensors = useMemo(() => {
    if (!fieldValue.trim()) return namedSensors;
    return namedSensors.filter(
      sensor =>
        sensor.name?.toLowerCase().includes(fieldValue.toLowerCase()) ||
        sensor.externalId?.toLowerCase().includes(fieldValue.toLowerCase())
    );
  }, [fieldValue, namedSensors]);

  const Sensors = ({ sensor }) => {
    const { name, externalId } = sensor || {};

    return (
      <div key={`sensorId-${sensor.id}`} className={cn(styles.namedSensorContainer, 'position-relative')}>
        <div className="d-flex justify-content-between pb-2">
          <div
            className={cn(styles.sensorName, 'col-9 pl-0 pr-2 text-truncate')}
          >
            {name}
          </div>

          <div
            className={cn(
              styles.deleteIcon,
              'mr-2 d-flex justify-content-center align-items-center'
            )}
            onClick={() => onClickEdit(sensor)}
          >
            <EditPencil />
          </div>

          <div
            className={cn(
              styles.deleteIcon,
              'd-flex justify-content-center align-items-center'
            )}
            onClick={() => onClickDeleteSensor(sensor)}
          >
            <DeleteIcon />
          </div>
        </div>
        <span className={styles.external}>{externalId}</span>
      </div>
    );
  };

  return namedSensors && filteredSensors.length > 0 ? (
    <div className={cn(styles.namedcontentWrapper)}>
      {filteredSensors.map(sensor => (
        <Sensors sensor={sensor} />
      ))}
    </div>
  ) : (
    <div
      className={cn(
        styles.noDataWrapper,
        'd-flex justify-content-center align-items-center h-100'
      )}
    >
      {FLABEL().SENSOR_NO_DATA}
    </div>
  );
};

export default NamedSensors;
